"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBotClient = void 0;
// Single source of truth for bot classification, shared by Faro RUM and the Astro site's Sentry
// init. Bots skew Web Vitals: on a low-traffic page one crawler sample can dominate the p75.
// `bot` is never matched bare — device models such as `CUBOT X19` would be caught as crawlers.
const KNOWN_BOT_TOKENS = [
    // Standalone or token-delimited `bot`, plus vendor crawlers whose name embeds it.
    '\\bbot\\b',
    'bot/',
    'googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google',
    'GoogleOther|Google-InspectionTool|AdsBot-Google|Storebot-Google|APIs-Google|FeedFetcher-Google',
    'bingbot|msnbot|msrbot|yandexbot|baiduspider|bytespider|DuckDuckBot|Applebot|petalbot|sogou|yeti',
    'ahrefsbot|SemrushBot|MJ12bot|dotbot|blekkobot|seznambot|ccbot|exabot|seekbot|ngbot|spbot',
    'Twitterbot|Facebot|facebookexternalhit|linkedinbot|slackbot|discordbot|telegrambot|redditbot',
    'chatgpt|gptbot|claudebot|perplexity|amazonbot|AddThis|MegaIndex|SemanticScholarBot',
    'antibot|jyxobot|yacybot|AISearchBot|tagoobot|woriobot|buzzbot|mlbot|purebot|Linguee Bot',
    'voilabot|citeseerxbot|twengabot|turnitinbot|scribdbot|sitebot|Adidxbot|Mail.RU_Bot|discobot',
    'wbsearchbot|edisterbot|gslfbot|aihitbot|intelium_bot|lssbot|careerbot|wocbot|acoonbot',
    'toplistbot|seokicks-robot|elisabot|blexbot|arabot|niki-bot|CrystalSemanticsBot|rogerbot|psbot',
    'InterfaxScanBot|urlappendbot|brainobot|Livelapbot|cXensebot|smtbot|bnf.fr_bot|OrangeBot',
    'memorybot|AdvBot|nerdybot|xovibot|findxbot|yoozBot|TweetmemeBot|archive.org_bot|NerdByNature.Bot',
    'web-archive-net.com.bot|Domain Re-Animator Bot|360Spider|lb-spider|openindexspider',
    // Generic crawler, scraper and synthetic-monitoring signatures.
    'crawler|crawling|spider|scrape|slurp|nutch|phpcrawl|httrack|heritrix|BUbiNG|crawler4j',
    'headless|phantomjs|puppeteer|playwright|lighthouse|pagespeed|gtmetrix|pingdom|uptimerobot',
    'changedetection|postrank|page2rss|linkdex|summify|proximic|ezooms|Qwantify|ltx71|Aboundex',
    'FAST-WebCrawler|FAST Enterprise Crawler|GingerCrawler|UsineNouvelleCrawler|SimpleCrawler',
    'backlinkcrawler|domaincrawler|webcompanycrawler|fr-crawler|it2media-domain-crawler',
    'ip-web-crawler.com|sistrix crawler|content crawler spider|gnam gnam spider|GrapeshotCrawler',
    // Non-browser HTTP clients and misc. indexing agents.
    'java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|webmon |grub.org|biglotron',
    'teoma|convera|gigablast|ia_archiver|netresearchserver|speedy|fluffy|bibnum.bnf|findlink',
    'panscient|IOI|ips-agent|yanga|Voyager|CyberPatrol|ec2linkfinder|findthatfile|europarchive.org',
    'ichiro|lssrocketcrawler|drupact|coccoc|integromedb|siteexplorer.info|WeSEE:Search|binlar',
    'CC Metadata Scaper|Lipperhey SEO Service|lipperhey|g00g1e.net|wotbox|A6-Indexer|ADmantX',
    'RetrevoPageAnalyzer|y!j-asr',
].join('|');
const BOT_UA_PATTERN = new RegExp(KNOWN_BOT_TOKENS, 'i');
const isBotClient = (candidate) => {
    if (!candidate) {
        return false;
    }
    if (candidate.webdriver === true) {
        return true;
    }
    return typeof candidate.userAgent === 'string' && BOT_UA_PATTERN.test(candidate.userAgent);
};
exports.isBotClient = isBotClient;
